module.exports = __webpack_public_path__ + "img/440.71379903.jpg";